import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import LockOpenOutlinedIcon from "@material-ui/icons/LockOpenOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { deleteUserAccountService, postBlockUser } from "../../../../../api";
import { AccordionSummary } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {
  ACCORDION_USER_INFO,
  MESSAGE_USER_BLOCK,
  MESSAGE_USER_UNBLOCK,
  USER_STATUS_BLOCK,
  USER_STATUS_BLOCKED,
  USER_STATUS_UNBLOCK,
} from "../../../../../utils/constants";
import AlertDialog from "../../../../../components/custom-dialog/CustomDialogComponent";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import { useIntl } from "react-intl";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";

const UserInfoComponent = ({
  classes,
  id,
  user,
  idCrm,
  handleGetUser,
  expanded,
  handleSetExpanded,
  type,
  unavailableStatus,
}) => {
  const intl = useIntl();

  const [blockedUser, setBlockedUser] = useState(null);
  const [openInfo, setOpenInfo] = useState(false);
  const [openDeleteUserDialog, setOpenDeleteUserDialog] = useState(false);

  useEffect(() => {
    if (user?.estadoUsuario?.descripcion) {
      setBlockedUser(user.estadoUsuario.descripcion === USER_STATUS_BLOCKED);
    }
  }, [user]);

  const handleBlockUser = () => {
    const blockUser = blockedUser ? USER_STATUS_UNBLOCK : USER_STATUS_BLOCK;
    const body = { operacion: blockUser, idUsuario: id };

    const message = { id: blockUser === USER_STATUS_BLOCK ? MESSAGE_USER_BLOCK : MESSAGE_USER_UNBLOCK, options: {} };
    postBlockUser(idCrm, body, handleGetUser, message);
  };

  const handleDeleteUser = () => {
    setOpenDeleteUserDialog(false);
    const message = { id: "messages.delete_user", options: { login: user.idLogin } };
    deleteUserAccountService(idCrm, id, handleGetUser, message);
  };

  const handleOpenInfo = (e) => {
    e.preventDefault();
    setOpenInfo((openInfo) => !openInfo);
  };

  const handleOpenDeleteUserDialog = (e) => {
    e.preventDefault();
    setOpenDeleteUserDialog((openDeleteUserDialog) => !openDeleteUserDialog);
  };

  const InfoModalContent = () => {
    return <Typography dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "custom.info.user_info" }) }} />;
  };

  const DeleteUserModalContent = () => {
    return (
      <Typography>
        {intl.formatMessage(
          { id: "custom.user.delete_confirmation" },
          { login: user?.idLogin, bold: (str) => <b>{str}</b> },
        )}
      </Typography>
    );
  };

  return (
    <>
      <Accordion expanded={!!expanded.includes(ACCORDION_USER_INFO)}>
        <AccordionSummary aria-controls="panel1bh-content" id="panel1bh-header">
          <div className={classes.accordionHeader}>
            <Typography
              onClick={() => handleSetExpanded(ACCORDION_USER_INFO)}
              variant={"h6"}
              className={classes.accordionTitle}
            >
              {intl.formatMessage({ id: "custom.user.user_info" })}
            </Typography>
            <Button startIcon={<InfoOutlinedIcon />} onClick={handleOpenInfo}>
              {intl.formatMessage({ id: "ra.action.more_info" })}
            </Button>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item xs={12} container spacing={4}>
            <Grid item xs={12} container spacing={4}>
              <Grid item xs={4} className={classes.keyValue}>
                <Typography variant={"caption"}>{intl.formatMessage({ id: "custom.login" })}</Typography>
                {user?.idLogin && (
                  <Tooltip placement={"bottom-start"} title={user.idLogin}>
                    <Typography className={classes.mailEllipsis}>{user.idLogin}</Typography>
                  </Tooltip>
                )}
              </Grid>
              <Grid item xs={2} className={classes.keyValue}>
                <Typography variant={"caption"}>{intl.formatMessage({ id: "custom.id_user" })}</Typography>
                <Typography>{id}</Typography>
              </Grid>
              <Grid item xs={2} className={classes.keyValue}>
                <Typography variant={"caption"}>{intl.formatMessage({ id: "custom.id_crm" })}</Typography>
                <Typography>{idCrm}</Typography>
              </Grid>
              <Grid item xs={4} className={classes.keyValue}>
                <Typography variant={"caption"}>
                  {intl.formatMessage({ id: "custom.user.type_description" })}
                </Typography>
                <Typography>{type}</Typography>
              </Grid>
              {/*<Grid item xs={4} className={classes.keyValue}>
                                <Typography
                                    variant={"caption"}>{intl.formatMessage({id: "custom.user.black_list_status"})}</Typography>
                                <Typography>{" - "}</Typography>
                            </Grid>*/}
            </Grid>
            <Grid item xs={12} container spacing={4}>
              {/*<Grid item xs={4} className={classes.keyValue}>
                                <Typography
                                    variant={"caption"}>{intl.formatMessage({id: "custom.user.last_login"})}</Typography>
                                <Typography>{" - "}</Typography>
                            </Grid>*/}
              {/*<Grid item xs={4} className={classes.keyValue}>
                                <Typography
                                    variant={"caption"}>{intl.formatMessage({id: "custom.user.last_login_status"})}</Typography>
                                <Typography>{" - "}</Typography>
                            </Grid>*/}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} container spacing={4}>
              <Grid item xs={4} className={classes.keyValue}>
                <Typography variant={"caption"}>
                  {intl.formatMessage({ id: "custom.user.block_user_status" })}
                </Typography>
                <div className={blockedUser ? classes.statusCell : ""}>
                  {blockedUser && <LockOutlinedIcon fontSize={"small"} />}
                  <Typography>{!user ? " - " : user?.estadoUsuario?.descripcion}</Typography>
                  {/*<Typography>
                    {!user
                      ? " - "
                      : intl.formatMessage({
                          id: blockedUser ? "custom.user.user_status_blocked" : "custom.user.user_status_unblocked",
                        })}
                  </Typography>*/}
                </div>
              </Grid>
              <Grid item md={4} lg={3}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({
                    id: blockedUser ? "custom.user.tooltip_unblock_user" : "custom.user.tooltip_block_user",
                  })}
                >
                  <span>
                    <Button
                      className={classes.button}
                      disabled={!user || unavailableStatus}
                      startIcon={blockedUser ? <LockOpenOutlinedIcon /> : <LockOutlinedIcon />}
                      onClick={handleBlockUser}
                    >
                      {intl.formatMessage({ id: blockedUser ? "custom.user.unblock" : "custom.user.block" })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item md={4} lg={3}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({ id: "custom.user.tooltip_delete_user" })}
                >
                  <span>
                    <Button
                      className={classes.warningButton}
                      disabled={!user || unavailableStatus}
                      startIcon={<DeleteOutlineRoundedIcon />}
                      onClick={handleOpenDeleteUserDialog}
                    >
                      {intl.formatMessage({ id: "custom.user.delete" })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <AlertDialog
        openAlert={openInfo}
        handleClose={handleOpenInfo}
        title={intl.formatMessage({ id: "custom.user.user_info" })}
        cancelButtonText={intl.formatMessage({ id: "ra.action.close" })}
        content={<InfoModalContent />}
      />
      <AlertDialog
        openAlert={openDeleteUserDialog}
        handleClose={handleOpenDeleteUserDialog}
        title={intl.formatMessage({ id: "custom.user.delete" })}
        cancelButtonText={intl.formatMessage({ id: "ra.action.close" })}
        content={<DeleteUserModalContent />}
        acceptButtonAction={handleDeleteUser}
        acceptButtonText={intl.formatMessage({ id: "ra.action.delete" })}
        warning
      />
    </>
  );
};

export default UserInfoComponent;
